import JSZip from 'jszip';

type ZIPable = { url: string; name: string };
export const downloadZIP = async (files: Array<ZIPable>, filename: string) => {
  const zip = new JSZip();

  try {
    await Promise.all(
      files.map(async (file) => {
        const response = await fetch(file.url);
        if (!response.ok) throw new Error(`Failed to fetch ${file.name}`);
        const blob = await response.blob();
        zip.file(file.name, blob);
      }),
    );

    const zipBlob = await zip.generateAsync({ type: 'blob' });

    const url = URL.createObjectURL(zipBlob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.style.visibility = 'hidden';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 40000);
  } catch (error) {
    console.error('Error creating ZIP:', error);
  }
};
